/**
 * Ensures a URL has an explicit scheme so it resolves as an absolute link.
 * Stored values without `https://` (e.g. "linkedin.com/in/foo") would otherwise
 * be treated as relative paths by the browser and 404. Empty/blank values are
 * returned as-is.
 */
export function normalizeUrl(url: string): string {
  if (!url.trim()) return url
  return /^https?:\/\//i.test(url) ? url : `https://${url}`
}
